export default {
      id: "unlock-usage",
      viewBox: "0 0 20 22",
      url: __webpack_public_path__ + "sprite.svg#unlock",
      toString: function () {
        return this.url;
      }
    }